export default __webpack_public_path__ + "static/media/user-placeholder.8a59356a.svg";